export const STORE_KEY_USER_BILLING_SUBSCRIPTION_ADJUST_PRICE = 'adjustPrice'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION = 'subscription'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_PAYMENTS = 'payments'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND = 'refund'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_COMP = 'comp'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_CANCEL = 'cancel'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_REACTIVATE = 'reactivate'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_PLANS = 'plans'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_PLAN_CHANGE = 'planChange'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_UPDATE_PAYMENT = 'updatePayment'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_PAYMENT_TOKEN = 'paymentToken'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND_DOWNGRADE = 'refundDowngrade'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND_CANCEL = 'refundCancel'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_REMOVE_PAYMENT_METHODS = 'removePaymentMethods'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_CURRENCY_CHANGE = 'currencyChange'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_INVOICES = 'invoices'
export const STORE_KEY_USER_BILLING_SUBSCRIPTION_INVOICE = 'invoice'
export const STORE_KEY_FINANCE_HANDLE_CHARGEBACK = 'handleChargeback'
export const STORE_KEY_FINANCE_CANCEL_SUBSCRIPTIONS_IN_BATCH = 'cancelSubscriptionsInBatch'
export const STORE_KEY_FINANCE_TURN_ON_AUTO_PAY_IN_BATCH = 'turnOnAutoPayInBatch'
export const STORE_KEY_FINANCE_POST_INVOICES_IN_BATCH = 'postInvoicesInBatch'
